import { AntTextArea } from "./styles";

export default AntTextArea;
